import * as React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useDispatch } from "react-redux";
import { logOutUser } from "../../redux/actions/loginActions";
import "./navbar.scss";
import {
  ADMIN_PROFILE,
  DASHBOARD,
  LANDING_PAGE,
} from "../../constant/routeContant";
import { useLocation, useNavigate } from "react-router-dom";
import SearchAutoComplete from "../custom/searchAutoComplete/SearchAutoComplete";
import * as clientAction from "../../redux/actions/clientAction";
import { checkPrivileges, showRighSideMenu } from "../../utils/rolesHelper";
import MenuIcon from "@mui/icons-material/Menu";
import { Grid } from "@mui/material";
import { logos } from "../../assets";
import BellIcon from "../../assets/BellIcon.svg";
import _ from "lodash";
import NotificationList from "../../feature/admin/shared/NotificationList";
import * as loginActions from "../../redux/actions/loginActions";
import { messaging } from "../../../src/firebase";
import { getToken, onMessage } from "firebase/messaging";
import Loader from "../common/Loader";
import { HBNEXT_ORG_ID, ORG_ID, SERVICE_TYPE } from "../../constant/constant";
import ReactGA from "react-ga4";
import { DARK, vapidKey } from "../../constant/constant";
import { useThemeContext } from "../../context";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { getUserBaseDivisionInfo, roleAccess } from "../../utils/helper";
import { useDebounce } from "../../utils/useDebounceSearch";

const pages = [];
const ResponsiveAppBar = ({ handleDrawerToggle, islanding = false }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const route = useLocation().pathname;
  const searchAllClientsReducerData = useSelector(
    (state) => state.searchAllClientsReducerData,
  );
  const autoSearchDataLoading = searchAllClientsReducerData.isLoading;
  const handleCloseNavMenu = () => {};
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [clients, setClients] = useState();
  const [clientSearchText, setClientSearchText] = useState("");
  const debouncedClientSearch = useDebounce(clientSearchText, 500);
  const serviceType = SERVICE_TYPE();
  const { mode, toggleTheme } = useThemeContext();

  const Profile_image = localStorage.getItem("profileImage")
    ? localStorage.getItem("profileImage")
    : "";
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const searchClient = (searchText) => {
    dispatch(clientAction.searchAllClients(searchText));
  };
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const userInfoProduct = userInfo?.product;
  const data = userInfoProduct?.map((val) => val?.key);
  const onChangeClients = (org) => {
    localStorage.setItem("orgId", org.key);
    localStorage.setItem("divisionId", 0);
    localStorage.setItem("orgName", org.value);
    localStorage.setItem("orgLogo", org.logoUrl);
    localStorage.setItem("ProcoreCompanyId", org.ProcoreCompanyId);
    localStorage.setItem("IsProcoreConnected", org.IsProcoreConnected);
    localStorage.setItem("orgStatus", org.Status);
    window.location.href = DASHBOARD;
    setClients(org);
  };

  const loginOrgID = localStorage.getItem("loginOrganizationId");
  const loginOrganizationName = localStorage.getItem("loginOrganizationName");
  const SwitchedClientOrgID = localStorage.getItem("orgId");
  const ProcoreId = localStorage.getItem("ProcoreCompanyId");
  const IsProcoreConnected = localStorage.getItem("IsProcoreConnected");
  const orgStatus = localStorage.getItem("orgStatus");

  const onMyOrgChange = () => {
    localStorage.setItem("orgId", loginOrgID);
    localStorage.setItem("orgName", loginOrganizationName);
    localStorage.setItem("companyName", loginOrganizationName);
    localStorage.removeItem("ProcoreCompanyId", ProcoreId);
    localStorage.removeItem("IsProcoreConnected", IsProcoreConnected);
    localStorage.removeItem("orgStatus", orgStatus);

    window.location.href = DASHBOARD;
    setAnchorEl(null);
  };

  const typeOnchange = (event) => {
    const searchText = event.target?.value || "";
    setClientSearchText(searchText);
    // const searchText = event.target?.value;
    // if (!_.isEmpty(searchText)) {
    //   searchClient(searchText.trim());
    // }
  };

  const getHeaderText = () => {
    const loginOrganizationId = localStorage.getItem("loginOrganizationId");
    const orgId = localStorage.getItem("orgId");
    const headerText =
      loginOrganizationId === orgId
        ? localStorage.getItem("name")
        : localStorage.getItem("orgName");
    return "Welcome, " + headerText;
  };
  const NotifiactionCount = useSelector((state) => state.notifiactionCountData);

  const updateNotifiactionCount = useSelector(
    (state) => state.updateNotifiactionCountData,
  );

  const [anchorElNotfication, NotficationsetAnchorEl] = useState(null);
  const [fcmTokens, setFcmToken] = useState("");
  const [notificationCounts, setNotificationCount] = useState(0);

  useEffect(() => {
    setNotificationCount(
      NotifiactionCount?.data?.result > 100
        ? "99+"
        : NotifiactionCount?.data?.result,
    );
  }, [NotifiactionCount]);

  const handleCloseOnNOtification = () => {
    NotficationsetAnchorEl(null);
    window.close();
  };
  const opens = Boolean(anchorElNotfication);
  const idd = opens ? "simple-popover" : undefined;
  const userId = localStorage.getItem("userId");
  const NotifiactionListDatas = useSelector(
    (state) => state.NotifiactionListData,
  );
  const loginData = useSelector((state) => state.login);
  const NotifiactionLogoutDatas = useSelector(
    (state) => state.NotifiactionLogoutData,
  );

  const updateNotifiactionListData = useSelector(
    (state) => state.updateNotifiactionListData,
  );

  const getNotifiactionListData = (data) => {
    dispatch(loginActions.getNotifiactionList(data));
  };

  const UpdateNotifiactionListDatas = (data) => {
    dispatch(loginActions.updateNotifiactionList(data));
  };

  const getNotifiactionCount = (data) => {
    dispatch(loginActions.getNotifiactionCount(data));
  };
  const UpdateNotifiactionCount = (data) => {
    dispatch(loginActions.updateNotifiactionCount(data));
  };

  const NotificationOClick = (event) => {
    NotficationsetAnchorEl(event.currentTarget);
    const data = "";
    UpdateNotifiactionCount(data);
    setNotificationCount(0);
  };
  useEffect(() => {
    if (
      updateNotifiactionListData?.isLoading === false &&
      updateNotifiactionListData?.status === "SUCCESS"
    ) {
      const defaultData = {
        page: 1,
        pageSize: 1000,
        status: "",
        userId: userId,
        search: "",
      };
      getNotifiactionListData(defaultData);
    }
  }, [updateNotifiactionListData]);

  useEffect(() => {
    if (
      location?.pathname === "/dashboard" ||
      location?.pathname === "/sw/dashboard"
    ) {
      const defaultData = {
        page: 1,
        pageSize: 1000,
        status: "",
        userId: userId,
        search: "",
      };
      getNotifiactionListData(defaultData);
      getNotifiactionCount();
    }
  }, [location?.pathname]);

  useEffect(() => {
    const defaultData = {
      page: 1,
      pageSize: 1000,
      status: "",
      userId: userId,
      search: "",
    };
    getNotifiactionListData(defaultData);
    getNotifiactionCount();
  }, []);

  // Check if browser is Safari
  const isMacSafari = () => {
    const ua = navigator.userAgent;
    return (
      ua.includes("Safari") &&
      ua.includes("Macintosh") &&
      !ua.includes("Chrome") &&
      !ua.includes("Chromium") &&
      !ua.includes("Edg")
    );
  };

  const getFCMToken = async () => {
    try {
      const token = await getToken(messaging, {
        vapidKey:
          "BPeBIj0NP9yrMH1Pc9QvLHVmsJHFNH_BodPYXgOCJYUdCyMoRkaDzQ-wK6mlLg5nDPuT_ngozhFIuqWlM0aJksI",
      });
      if (token) {
        setFcmToken(token);
        return token;
      }
      return null;
    } catch (error) {
      console.error("Error getting FCM token:", error);
      return null;
    }
  };

  const initializePushNotifications = async () => {
    try {
      // Use Notification.permission
      const currentPermission = Notification.permission;

      if (currentPermission === "granted") {
        const token = await getFCMToken();
        return token;
      }

      if (currentPermission === "denied") {
        console.log("User has blocked notifications");
        return null;
      }

      // For Safari,
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        const token = await getFCMToken();
        return token;
      }
      return null;
    } catch (error) {
      console.error("Error initializing push notifications:", error);
      return null;
    }
  };

  const postNotifiactionLoginData = async (token) => {
    if (!token || !userId) return;

    const defaultData = {
      mapList: [
        {
          userId: userId,
          fcmToken: token,
        },
      ],
    };
    dispatch(loginActions.postNotifiactionLogin(defaultData));
  };

  useEffect(() => {
    if (loginData.status === "SUCCESS") {
      const handleNotifications = async () => {
        try {
          if (isMacSafari()) {
            setTimeout(async () => {
              const token = await initializePushNotifications();
              if (token) {
                await postNotifiactionLoginData(token);
              }
            }, 300);
          } else {
            const token = await initializePushNotifications();
            if (token) {
              await postNotifiactionLoginData(token);
            }
          }
        } catch (error) {
          console.error("Error handling notifications:", error);
        }
      };
      handleNotifications();
    }
  }, [loginData.status, userId]);

  const postNotifiactionLogOutData = (data) => {
    dispatch(loginActions.postNotifiactionLogout(data));
  };

  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {
      getNotifiactionCount();
      const defaultData = {
        page: 1,
        pageSize: 1000,
        status: "",
        userId: userId,
        search: "",
      };
      getNotifiactionListData(defaultData);
    });

    return () => {
      unsubscribe();
    };
  }, [userId]);

  useEffect(() => {
    setNotificationCount(
      NotifiactionCount?.data?.result > 100
        ? "99+"
        : NotifiactionCount?.data?.result,
    );
  }, [NotifiactionCount]);

  const logoutClickHandler = () => {
    const defaultData = {
      userId: userId,
      fcmToken: fcmTokens,
    };
    postNotifiactionLogOutData(defaultData);
  };

  useEffect(() => {
    if (
      NotifiactionLogoutDatas?.isLogout &&
      NotifiactionLogoutDatas?.isLoading === false
    ) {
      dispatch(logOutUser());
    }
  }, [NotifiactionLogoutDatas]);

  const pathName = window.location.pathname;
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: pathName, title: pathName });
  }, [pathName]);
  useEffect(() => {
    document.body.className = mode === "light" ? "light-mode" : "dark-mode";
    console.log("mode", mode);
  }, [mode]);

  const addChatbotScript = () => {
    const existingWidget = document.getElementById("safety-chatbot-widget");
    if (existingWidget) {
      existingWidget.style.display = "";
      return;
    }

    const existingScript = document.querySelector(
      'script[src="https://lobster-app-qdt2u.ondigitalocean.app/static/widget.js"]',
    );

    if (!existingScript) {
      const script = document.createElement("script");
      script.src =
        "https://lobster-app-qdt2u.ondigitalocean.app/static/widget.js";
      script.async = true;
      script.setAttribute("data-agent-id", "acme-safety-001");
      script.setAttribute("data-chatbot-id", "acme-workplace-assistant");
      script.setAttribute("data-name", "Safety Chatbot (Beta)");
      script.setAttribute("data-primary-color", "#1a446f");
      script.setAttribute("data-secondary-color", "#333333");
      script.setAttribute("data-button-background-color", "#1a446f");
      script.setAttribute("data-theme", mode === "dark" ? "dark" : "light");
      script.setAttribute(
        "data-starting-message",
        "Hello! How can I help you today?",
      );
      script.setAttribute(
        "data-logo",
        "https://safetycloudfiles-qa.s3.amazonaws.com/20250702T130750236Z577747.png",
      );
      script.setAttribute(
        "data-disclaimer",
        "Always verify outputs before making critical decisions.",
      );
      script.setAttribute("data-powered-by", "Powered by HBNext");
      script.setAttribute("data-allow-expand", "true");
      document.body.appendChild(script);
    }
  };

  const removeChatbotScript = (destroy = false) => {
    if (destroy) {
      const script = document.querySelector(
        'script[src="https://lobster-app-qdt2u.ondigitalocean.app/static/widget.js"]',
      );
      if (script) {
        script.remove();
      }
      const widgetContainer = document.getElementById("safety-chatbot-widget");
      if (widgetContainer) {
        widgetContainer.remove();
      }
    } else {
      const widgetContainer = document.getElementById("safety-chatbot-widget");
      if (widgetContainer) {
        widgetContainer.style.display = "none";
      }
    }
  };

  const showMenu = showRighSideMenu();
  const { hasBaseDivisionAdminAccess } = getUserBaseDivisionInfo();
  const divisionAdminRole = hasBaseDivisionAdminAccess;
  const {
    OSHAManagementRole,
    HbnClientPartnerRole,
    HbnClientSystemRole,
    SupervisorRole,
    HBNLimitedInspectorRole,
  } = roleAccess();

  useEffect(() => {
    const { isSafety } = showMenu;

    const hasChatbotRole =
      OSHAManagementRole ||
      HbnClientPartnerRole ||
      HbnClientSystemRole ||
      SupervisorRole ||
      HBNLimitedInspectorRole;

    const shouldShow =
      isSafety &&
      (checkPrivileges([12]) || hasChatbotRole || divisionAdminRole) &&
      location.pathname !== LANDING_PAGE;

    if (shouldShow) {
      addChatbotScript();
    } else {
      removeChatbotScript();
    }
  }, [showMenu]);

  const isFirstRender = React.useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (!_.isEmpty(debouncedClientSearch)) {
      searchClient(debouncedClientSearch.trim());
    }
  }, [debouncedClientSearch]);

  return (
    <div className="header-over">
      {NotifiactionLogoutDatas.isLoading && <Loader />}
      <AppBar className="topHeader header-box" position="static">
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Grid
              container
              className={
                islanding
                  ? "topHeaderBox islanding-top-headerBox"
                  : "topHeaderBox"
              }
            >
              <div item xs={2} sm={2} md={2} className="menuIconMobile">
                <MenuIcon
                  onClick={handleDrawerToggle}
                  data-testid="navbar-mobile-menu"
                />
              </div>
              {islanding && (
                // <div className="logo">
                <Grid item lg={2.5} md={3} xs={2}>
                  {mode === DARK ? (
                    <img
                      src={logos?.logoWhite}
                      width="180px"
                      className="logoResponsive"
                      alt="no logo"
                    />
                  ) : (
                    <img
                      src={logos?.logo}
                      width="180px"
                      className="logoResponsive"
                      alt="no logo"
                    />
                  )}
                </Grid>
                // </div>
              )}

              <Grid
                item
                md={islanding ? 5 : 7}
                xs={8}
                lg={islanding ? 5 : 7}
                className="leftBox WelcomeUserText"
              >
                <h1 className="welcomeUser " data-testid="navbar-welcome-text">
                  {getHeaderText()}
                </h1>
              </Grid>
              <Grid
                item
                md={islanding ? 4.5 : 3}
                xs={2}
                lg={islanding ? 4.5 : 5}
                container
                className="rightBox profieImages"
              >
                <Grid>
                  {pages.map((page) => (
                    <Button
                      className="pages-title"
                      key={page}
                      onClick={handleCloseNavMenu}
                      sx={{ my: 2, color: "white", display: "block" }}
                    >
                      {page}
                    </Button>
                  ))}
                </Grid>
                <Grid item md={7} xs={7} sm={7} className="searchAutoMobile">
                  {checkPrivileges([12, 15]) && !islanding && (
                    <SearchAutoComplete
                      name="orgName"
                      placeholderText="Search organization"
                      noOptionsTextMsg="No organization"
                      optionsData={
                        autoSearchDataLoading
                          ? []
                          : (searchAllClientsReducerData?.data ?? [])
                      }
                      typeOnchange={(event, value) =>
                        typeOnchange(event, value)
                      }
                      isKeyValuePair={true}
                      value={clients}
                      onChange={(event, value) => onChangeClients(value)}
                      isLoading={autoSearchDataLoading}
                    />
                  )}
                </Grid>
                {serviceType === "1" && (
                  <Grid
                    item
                    lg={1.5}
                    md={2}
                    xs={2}
                    sm={2}
                    mt={1}
                    className="NotificationStyles"
                  >
                    {!islanding && (
                      <div className="notification-badge">
                        <img
                          src={BellIcon}
                          alt="Notification Icon"
                          onClick={NotificationOClick}
                        />
                        {notificationCounts > 0 && (
                          <span
                            className="badge"
                            data-testid="navbar-notification-count"
                          >
                            {notificationCounts}
                          </span>
                        )}
                      </div>
                    )}
                    <NotificationList
                      id={idd}
                      open={opens}
                      anchorEl={anchorElNotfication}
                      handleClose={handleCloseOnNOtification}
                      NotifiactionListDatas={NotifiactionListDatas?.data}
                      UpdateNotifiactionListData={UpdateNotifiactionListDatas}
                    />
                  </Grid>
                )}
                <Grid
                  item
                  md={2}
                  xs={2}
                  sm={2}
                  iconRightBox
                  className="ProfileImageIcon"
                >
                  <IconButton
                    sx={{ p: 0 }}
                    onClick={handleClick}
                    className="Profile_Btn"
                  >
                    <Avatar alt="profile image" src={Profile_image} />
                  </IconButton>
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                    className="profileDropdown"
                  >
                    {loginOrgID === SwitchedClientOrgID ? (
                      ""
                    ) : (
                      <MenuItem
                        onClick={onMyOrgChange}
                        data-testid="navbar-menu-my-org"
                      >
                        My Organization
                      </MenuItem>
                    )}
                    {!islanding && (
                      <MenuItem
                        onClick={() => {
                          navigate(ADMIN_PROFILE, {
                            state: { fromDashboard: false },
                          });
                          setAnchorEl(null);
                        }}
                      >
                        Profile
                      </MenuItem>
                    )}
                    {!islanding && data?.length > 1 && (
                      <MenuItem
                        onClick={() => {
                          navigate(LANDING_PAGE);
                          setAnchorEl(null);
                        }}
                      >
                        Service Type
                      </MenuItem>
                    )}
                    <MenuItem
                      onClick={logoutClickHandler}
                      data-testid="navbar-menu-logout"
                    >
                      Logout
                    </MenuItem>
                  </Menu>
                </Grid>
                <Grid item md={1} xs={1} sm={1}>
                  {
                    <IconButton
                      sx={{ ml: 1 }}
                      onClick={() => {
                        toggleTheme();
                        removeChatbotScript(true);
                        addChatbotScript();
                      }}
                      color="inherit"
                    >
                      {mode === DARK ? (
                        <Brightness7Icon className="iconWhite" />
                      ) : (
                        <Brightness4Icon />
                      )}
                    </IconButton>
                  }
                </Grid>
              </Grid>
            </Grid>
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  );
};
export default ResponsiveAppBar;
